import type { ComponentProps } from 'react';
import React from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { SectionHeader } from '../../Header';
import { HorizontalScrollRailNav } from './HorizontalScrollRailNav';

// ────────────────────────────────────────────────────────────────────────────────

export const HorizontalScrollRailHeader = (
  props: HorizontalScrollRailHeaderProps,
) => {
  const {
    heading = '',
    subtitle = '',
    headerVariation,
    withoutHeaderBorder,
    count,
    countPosition,
    ...railNavProps
  } = props;

  return (
    <View style={styles.headerWrapper}>
      <SectionHeader
        heading={heading}
        subtitle={subtitle}
        variation={headerVariation}
        withoutBorder={withoutHeaderBorder}
        count={countPosition === 'left' ? count : 0}
      >
        <HorizontalScrollRailNav
          {...railNavProps}
          count={countPosition === 'right' ? count : 0}
        />
      </SectionHeader>
    </View>
  );
};

// ─── STYLES ─────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  headerWrapper: {
    paddingBottom: theme.spacing.medium,
  },
});

// ─── TYPES ──────────────────────────────────────────────────────────────────────

export type HorizontalScrollRailHeaderProps = {
  readonly heading?: string;
  readonly count?: number;
  readonly subtitle?: string;
  readonly countPosition?: 'left' | 'right';
  readonly headerVariation?: ComponentProps<typeof SectionHeader>['variation'];
  readonly withoutHeaderBorder?: ComponentProps<
    typeof SectionHeader
  >['withoutBorder'];
} & ComponentProps<typeof HorizontalScrollRailNav>;
